import { FieldErrors, StudentRow } from '../types/ProvisionalPromotionTypes';

const withinAcademicYear = (course: any, reference: Date) => {
  if (!course?.academicYear?.from || !course?.academicYear?.to) return false;
  const from = new Date(course.academicYear.from);
  const to = new Date(course.academicYear.to);
  return reference >= from && reference <= to;
};

const findCurrentCourseInfo = (student: any, reference: Date) => {
  const courseInfoArr = Array.isArray(student.courseInfo)
    ? student.courseInfo
    : [];
  return courseInfoArr.find((course: any) =>
    withinAcademicYear(course, reference)
  );
};

const findRollOverInfo = (student: any, rolloverAy: string) => {
  const rollOverInfoArr = Array.isArray(student.rollOverInfo)
    ? student.rollOverInfo
    : [];
  return rollOverInfoArr.find((info: any) => info?.academicYear === rolloverAy);
};

const getConcessionsRemark = (rollOverInfoForNewAy: any): string => {
  const remark = rollOverInfoForNewAy?.concessionsWaiversRemark;
  return remark && String(remark).trim().length > 0 ? remark : '';
};

const formatGradeDivision = (grade?: string, division?: string) => {
  if (!grade && !division) {
    return '';
  } else if (!division) {
    return `${grade}`;
  }
  return `${grade}-${division}`;
};

const mapStudentsToRows = (
  studentsData: any[],
  rolloverAy: string
): StudentRow[] => {
  const now = new Date();
  return (studentsData || []).map((student: any): StudentRow => {
    const currentCourse = findCurrentCourseInfo(student, now);
    const rollOverInfo = findRollOverInfo(student, rolloverAy);

    return {
      id: student?.id,
      enrollmentNo: student?.enrollmentNo || '',
      rollNo: currentCourse?.rollNo || '',
      name: student?.name || '',
      currentGradeDivision: currentCourse
        ? formatGradeDivision(currentCourse.grade, currentCourse.division)
        : '',
      rollOverGradeAndDivision: rollOverInfo
        ? formatGradeDivision(rollOverInfo.grade, rollOverInfo.division)
        : '',
      applicableConcessions: getConcessionsRemark(rollOverInfo)
    };
  });
};

const renderValue = (placeholder: string) => (selected: any) =>
  selected && String(selected).trim() !== '' ? String(selected) : placeholder;

const parseYupErrors = (err: any): FieldErrors => {
  if (err?.name !== 'ValidationError' || !Array.isArray(err?.inner)) return {};
  const fieldErrors: FieldErrors = {};
  err.inner.forEach((e: any) => {
    if (e?.path && !fieldErrors[e.path]) fieldErrors[e.path] = e.message;
  });
  return fieldErrors;
};

export { mapStudentsToRows, renderValue, parseYupErrors };
